import { cn } from "../utils/cn.js";

export interface WordmarkProps {
  /** Pixel size of the wordmark. Default 18 (matches the brand sidebar). */
  size?: number;
  /** Color of the "Wise" portion. "Owl" is always mustard. */
  className?: string;
}

/**
 * Wordmark — "Wise" in ink + "Owl" in mustard + "Talks" in ink, Lora serif.
 *
 * This is the canonical app-shell wordmark per the brand bundle. The
 * full WOT (with-mic) logo is reserved for marketing surfaces only.
 */
export const Wordmark = ({ size = 18, className }: WordmarkProps) => (
  <span
    className={cn(
      "inline-flex items-baseline gap-1 font-serif font-semibold leading-none text-ink",
      className,
    )}
    style={{ fontSize: size, letterSpacing: 0.2 }}
  >
    <span>Wise</span>
    <span className="text-mustard">Owl</span>
    <span>Talks</span>
  </span>
);
